module.exports = __webpack_public_path__ + "static/media/bg2.a6c4bbe6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/backgrounds/bg2.jpg
// module id = 1074
// module chunks = 0